// extracted by mini-css-extract-plugin
export var cardIcon = "_ak-5";
export var cardIconUnframed = "_ak-9";
export var checkboxCard = "_ak-0";
export var checkboxCardSelected = "_ak-4";
export var disabled = "_ak-2";
export var interactive = "_ak-1";
export var outerBorder = "_ak-3";
export var spacerMedium = "_ak-8";
export var spacerSmall = "_ak-7";
export var spacerXsmall = "_ak-6";